export const DEFAULT_CUSTOMIZATION: ICustomizationData = {
    companyName: "Pretectum",
    logo: "",
    logoSize: undefined,
    sloganFooter: "Intelligent choice for good customer data",
    colorHeaderFooter: "#fafafa",
    colorNavigationBar: "#001d3d",
    colorNavigationFont: "#ffffff",
    colorSelectedHeader: "#003566",
    colorPrimaryButtons: "#1677ff",
    colorSecondaryButtons: "#2e3e81",
    colorForm: "#f1f1f1",
    colorSelectedRow: "#e6f4ff",
    colorLabel: "#344054",
    colorParagraphFont: "#1d2939",
    colorMainHeadingFont: "#101828",
    colorSubheadingFont: "#344054",
};

export const ALTERNATE_DEFAULT_CUSTOMIZATION: ICustomizationData = {
    companyName: "Pretectum",
    logo: undefined,
    logoSize: undefined,
    sloganFooter: "Intelligent choice for good customer data",
    colorHeaderFooter: "#446ba2",
    colorNavigationBar: "#1B1C1D",
    colorNavigationFont: "#000000",
    colorSelectedHeader: "#1890FF",
    colorPrimaryButtons: "#446ba2",
    colorSecondaryButtons: "#D1D5D8",
    colorForm: "#FFFFFF",
    colorSelectedRow: "#E6F4FF",
    colorLabel: "#000000",
    colorParagraphFont: "#121212",
    colorMainHeadingFont: "#333333",
    colorSubheadingFont: "#1B1C1D",
};
